<div class="container-narrow my-5">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-6">
      <div class="card border-0 shadow">
        <div class="card-body">
          <ng-container *ngIf="this.displayConfirmation">
            <h1 class="h3 fw-bolder"
                [translate]="'MAILING.UNSUBSCRIBE.CONFIRMATION.TITLE'">
            </h1>
            <p [translate]="'MAILING.UNSUBSCRIBE.CONFIRMATION.TEXT'"
               [translateParams]="{ messageType: ('MAILING.UNSUBSCRIBE.MESSAGE-TYPES.' + messageType | translate) }">
            </p>
            <button type="button"
                    [translate]="'MAILING.UNSUBSCRIBE.CONFIRMATION.BUTTON'"
                    class="btn btn-primary px-4 mt-4"
                    (click)="sendUnsubscribeRequest()">
            </button>
          </ng-container>
          <ng-container *ngIf="this.displayError">
            <h1 class="h3 fw-bolder"
                [translate]="'MAILING.UNSUBSCRIBE.ERROR.TITLE'"></h1>
            <p [translate]="'MAILING.UNSUBSCRIBE.ERROR.TEXT'"></p>
          </ng-container>
          <ng-container *ngIf="this.hasSuccessfullyUnsubscribed">
            <h1 class="h3 fw-bolder"
                [translate]="'MAILING.UNSUBSCRIBE.SUCCESS.TITLE'"></h1>
            <p [translate]="'MAILING.UNSUBSCRIBE.SUCCESS.TEXT'"
               [translateParams]="{ messageType: ('MAILING.UNSUBSCRIBE.MESSAGE-TYPES.' + messageType | translate) }">
            </p>
            <p [translate]="'MAILING.UNSUBSCRIBE.SUCCESS.HINT'"></p>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
